import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UpdateStoresService {
  constructor(private http: HttpClient) { }

  /**
   * 店舗情報ファイル取り込みAPI呼び出し
   * @param file フォームデータ
   */
  public exportStores(file: FormData) {
    let httpOptions: any = {
      // ヘッダ情報
      headers: new HttpHeaders({
        'contet-type': 'multipart/form-data',
      })
    };
    return this.http.post(environment.apiEndPoint + 'api/update-stores/import-file', file, httpOptions) as Observable<any>;
  }
}
